import { EMAIL_TOKENS } from "../../styles/tokens";
import { applyStyleMap } from "../shared-block-styles";

import { CSSProperties } from "react";

/** A blockquote's appearance, for the canvas and for the inbox alike. */
export function getBlockquoteStyles(
  attrs: Record<string, unknown>,
): CSSProperties {
  const styles: CSSProperties = {
    fontFamily: EMAIL_TOKENS.fontFamily.sans,
    fontSize: EMAIL_TOKENS.fontSize.base,
    lineHeight: EMAIL_TOKENS.lineHeight.normal,
    color: EMAIL_TOKENS.colors.text.secondary,
    fontStyle: "italic",
    borderLeft: `3px solid ${attrs.borderColor as string}`,
    margin: "0",
    paddingTop: "0",
    paddingRight: "0",
    paddingBottom: "0",
    paddingLeft: EMAIL_TOKENS.spacing.md,
    ...(attrs.textAlign
      ? { textAlign: attrs.textAlign as CSSProperties["textAlign"] }
      : {}),
  };
  applyStyleMap(styles, attrs);
  return styles;
}
